export default __webpack_public_path__ + "static/media/plus-grey.25e7a3eb.svg";